import { Component } from 'react';
import * as Sentry from '@sentry/browser';
import { withStyles } from '@material-ui/styles';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import Error from '@material-ui/icons/Error';

import theme from '../utils/styles/theme';

const ErrorCard = withStyles({
  root: {
    backgroundColor: theme.colors.error[0],
    borderLeft: `5px solid ${theme.colors.error[1]}`,
    overflow: 'hidden',
  },
})(Card);

const ErrorCardActionArea = withStyles({
  root: {
    color: theme.colors.text[3],
    fontSize: theme.fontSizes[2],
    padding: theme.space[3],
    paddingLeft: '48px',
  },
})(CardActionArea);

const ErrorCardHeader = withStyles({
  root: {
    color: theme.colors.error[2],
    padding: theme.space[2],
  },
  title: {
    color: theme.colors.error[2],
    fontSize: theme.fontSizes[2],
    fontWeight: theme.fontWeights[5],
  },
})(CardHeader);

const ErrorCardContent = withStyles({
  root: {
    color: theme.colors.text[3],
    fontStyle: 'italic',
    padding: theme.space[2],
    paddingLeft: '48px',
  },
})(CardContent);

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      errorMsg: error.toString(),
      hasError: true,
    };
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error);
  }

  render() {
    const { errorMsg, hasError } = this.state;

    if (hasError) {
      return (
        <ErrorCard>
          <ErrorCardHeader avatar={<Error />} title="Error" />
          <ErrorCardContent>{errorMsg}</ErrorCardContent>
          <ErrorCardActionArea>
            Sorry, something went wrong. Try refreshing the page.
          </ErrorCardActionArea>
        </ErrorCard>
      );
    }

    return this.props.children;
  }
}
